// import { HttpClient } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable()
export class BlockchainHttpService {
  // private readonly api = '';

  constructor() {} // private _http: HttpClient

  getBlockchainStatus(): Observable<boolean> {
    // TODO: Replace with actual API call
    return of(true);
  }
}
